<script setup lang="ts">
import { useI18n } from "vue-i18n";

const props = defineProps<{
  level: number | null;
  size?: "sm" | "md";
}>();

const { t } = useI18n();

const emit = defineEmits(["click"]);

const handleClick = () => {
  emit("click");
};
</script>

<template>
  <Tooltip theme="light" :text="t('card.gear-level.tooltipLegend')">
    <div
      @click.stop="handleClick"
      :class="{
        ' whitespace-nowrap rounded-lg': true,
        'bg-[#40AA48]': level !== null && level >= 7,
        'bg-[#32aecd]': level !== null && level >= 5 && level <= 6,
        'bg-[#F2BD0D]': level !== null && level >= 3 && level <= 4,
        'bg-[#E38112]': level !== null && level >= 1 && level <= 2,
        'text-xs py-0.5': size === 'sm',
        'text-xs md:text-sm py-0.5': !size,
      }"
      class="rounded-md px-1 score-container grid place-content-center text-black min-w-7 font-sans font-medium"
    >
      {{ t("_shared.lvl") }} {{ level || 0 }}
    </div>
  </Tooltip>
</template>
